import { Box, MenuItem, Select, SelectChangeEvent } from "@mui/material";

import { useContext, useEffect, useState } from "react";

import { updateUserPreferences } from "@/slices/auth/authThunk";
import { setTheme as setThemeAction } from "@/slices/changeTheme/changeThemeReducer";
import { useDispatch, useSelector } from "@/store";
import { rootReducerName } from "@/store/rootReducer";
import { ThemeContext } from "@/theme/ThemeProvider";
import { useTranslation } from "next-i18next";

const themes = [
  { id: "PureLightTheme", name: "Light", type: "light", primary: "#f4f4f4" },
  { id: "DarkSpacesTheme", name: "Dark", type: "dark", primary: "#2b2f34" }
  // { id: "PureLightTheme", name: "Pure Light", type: "light", primary: "#030303ff" },
  // { id: "GreyGooseTheme", name: "Grey Goose", type: "light", primary: "#2442AF" },
  // { id: "PurpleFlowTheme", name: "Purple Flow", type: "light", primary: "#9b52e1" },
  // { id: "DarkSpacesTheme", name: "Dark Spaces", type: "dark", primary: "#CB3C1D" },
  // { id: "GreenFieldsTheme", name: "Green Fields", type: "dark", primary: "#44a574" },
  // { id: "NebulaFighterTheme", name: "Nebula Fighter", type: "dark", primary: "#8C7CF0" }
];

export const ThemeSwitcher = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const setThemeContext = useContext(ThemeContext);
  const currentThemeRedux = useSelector((state) => state[rootReducerName.changeTheme].curTheme);
  const user = useSelector((state) => state.auth?.user);

  const [currentTheme, setCurrentTheme] = useState(currentThemeRedux || "DarkSpacesTheme");

  useEffect(() => {
    if (currentThemeRedux) {
      setCurrentTheme(currentThemeRedux);
    }
  }, [currentThemeRedux]);

  const handleThemeChange = async (event: SelectChangeEvent<string>) => {
    const newThemeId = event.target.value;
    const themeConfig = themes.find((t) => t.id === newThemeId);

    setCurrentTheme(newThemeId);
    setThemeContext(newThemeId);
    dispatch(setThemeAction(newThemeId));

    if (user?.id) {
      try {
        await dispatch(
          updateUserPreferences({
            theme_id: newThemeId,
            theme_mode: themeConfig?.type as "light" | "dark"
          })
        ).unwrap();
      } catch (err) {
        // ignore
      }
    }
  };

  return (
    <Select
      value={currentTheme}
      onChange={handleThemeChange}
      size="small"
      fullWidth
      sx={{
        minWidth: 120,
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          gap: 1
        }
      }}
    >
      {themes.map((theme) => (
        <MenuItem key={theme.id} value={theme.id}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: theme.primary,
              mr: 1
            }}
          />
          {t(theme.name)}
        </MenuItem>
      ))}
    </Select>
  );
};
